import Row from '@components/Row';
import Stepper from '@components/Stepper';
import useAppCustom from '@hooks/useAppCustom';
import { OrderLine } from '@models/order';

import useModifyCartItem from './hooks/useModifyCartItem';

interface Props {
    item: OrderLine;
}

function CartFooter({ item }:Props) {
    const { handleDecrease, handleIncrease } = useModifyCartItem(item);
    const { itemMaxQuantity } = useAppCustom().item;
    return (
        <Row fullWidth justify='flex-end'>
            <Stepper value={item.quantity}
                max={itemMaxQuantity}
                min={1}
                increase={handleIncrease}
                decrease={handleDecrease} />
        </Row>
    );
}

export default CartFooter;
